import { dataHooks } from '@wix/data-hooks';

export const templateBuilderSwitchDataHooks = dataHooks<{
  trigger: {};
}>('template-builder-switch');
